import { useNavigate } from 'react-router-dom';

const UnknownRoute = () => {
	const navigate = useNavigate();
	navigate('/PageNotFound');
	return <></>;
};

export default UnknownRoute;
